import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { defineComponent, h } from '@vue/composition-api';
import Icon, { IconProps } from './Icon.js';

/**
 * 帮助快速生成自定义Icon组件
 */

var generateIcon = function generateIcon(svg, options) {
  return defineComponent({
    name: options === null || options === void 0 ? void 0 : options.name,
    props: IconProps,
    emits: ['click'],
    setup: function setup(props, context) {
      return function () {
        return h(Icon, {
          "props": _objectSpread2({}, props),
          "attrs": {
            "svg": svg
          },
          "on": {
            "click": function click(e) {
              return context.emit('click', e);
            }
          }
        });
      };
    }
  });
};

export { generateIcon as default };
//# sourceMappingURL=generateIcon.js.map
